import {
  Button,
  CircularProgress,
  createStyles,
  IconButton,
  makeStyles,
  Menu,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import DescriptionIcon from '@material-ui/icons/Description';
import React, { useCallback, useState } from 'react';
import { useFeedback } from '../../../../../hooks/feedback';
import { MedicalCertificateDTO } from '../../../../../models/dto/MedicalCertificateDTO';
import { api } from '../../../../../services/api';

interface DownloadMedicalStatementMenuProps {
  options: MedicalCertificateDTO[];
}

const useStyles = makeStyles(() =>
  createStyles({
    certificateMenuItem: {
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }),
);

const DownloadMedicalStatementMenu: React.FC<DownloadMedicalStatementMenuProps> = ({
  options,
}: DownloadMedicalStatementMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<any>();
  const [downloading, setDownloading] = useState(false);
  const { addFeedback } = useFeedback();
  const classes = useStyles();

  const handleDocumentDownloadClick = useCallback(
    async (event: React.MouseEvent<any>, fileHash: string) => {
      setDownloading(true);
      setAnchorEl(event.currentTarget);
      event.stopPropagation();
      setAnchorEl(undefined);
      await api
        .get(`/repositoriodigital/arquivos/${fileHash}`, {
          responseType: 'blob',
          headers: { get: { Accept: 'application/octet-stream' } },
        })
        .then(response => {
          const disposition = response.headers['content-disposition'];
          let filename = '';
          if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        })
        .catch(_error => {
          addFeedback({
            type: 'warning',
            closeTimeout: 7000,
            description: 'Documento não encontrado!',
          });
        });
      setDownloading(false);
    },
    [addFeedback],
  );

  return (
    <>
      {downloading ? (
        <CircularProgress
          size={20}
          style={{
            top: 4,
            position: 'relative',
          }}
        />
      ) : (
        <>
          {options?.length > 1 ? (
            <div>
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                color="primary"
                onClick={event => {
                  event.stopPropagation();
                  setAnchorEl(event?.currentTarget);
                }}
              >
                {`${options?.length} Atestados`}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
              >
                {options?.map(item => {
                  return (
                    <MenuItem
                      onClick={event => {
                        handleDocumentDownloadClick(event, item.hashArquivo);
                      }}
                      className={classes.certificateMenuItem}
                    >
                      {`${item.id} - ${item.dataJustificativa}`}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          ) : (
            <IconButton
              color="primary"
              disabled={!options || options?.length === 0}
              onClick={event => {
                handleDocumentDownloadClick(event, options[0].hashArquivo);
              }}
            >
              <DescriptionIcon />
            </IconButton>
          )}
        </>
      )}
    </>
  );
};

export default DownloadMedicalStatementMenu;
